import React from 'react';
import { useSelector } from 'react-redux';

import styles from './ProportionateDistributionMethod.module.scss';

import PageWrapper from '../../components/PageWrapper/PageWrapper';
import ProgressButtons from '../../components/Progress/ProgressButtons/ProgressButtons';
import ProgressBar from '../../components/Progress/ProgressBar/ProgressBar';
import DestinationOption from '../../components/DestinationOption/DestinationOption';
import {
  PROPORTIONATE_DISTRIBUTION_METHOD_STEP,
  REINVEST_STEP,
  TOLL_FREE_NUMBER,
  DISTRIBUTION_METHOD_STEP,
  FREQUENCY_STEP,
  ADDRESS_STEP,
  BANK_STEP,
} from '../../settings/settings';
import {
  getRMDfunds,
  getBalanceAsOfDate,
} from '../../redux/modules/UserFunds/userFunds.selectors';
import RMLConnection from '../../components/RMLConnection/RMLConnection';
import HelpBox from '../../components/HelpBox/HelpBox';
import FundDisplayText from './FundDisplayText';
import { getSelectedDestination } from '../../redux/modules/shoppingCart/shoppingCart.selectors';

const ProportionateDistributionMethod = (props) => {
  const {
    ROLLOVER_IRA: { unlockedFunds: rolloverUnlockedFunds },
    TRADITIONAL_IRA: { unlockedFunds: traditionalUnlockedFunds },
  } = useSelector(getRMDfunds);
  const balanceAsOfDate = useSelector(getBalanceAsOfDate);
  const selectedDestination = useSelector(getSelectedDestination);
  return (
    <div className="rmd-distribution-wrapper">
      <div className="sticky-header">
        <div className="heading">Auto-RMD Setup</div>
        <ProgressButtons
          edit={props.edit}
          currentStep={PROPORTIONATE_DISTRIBUTION_METHOD_STEP}
          previousStep={DISTRIBUTION_METHOD_STEP}
          payload={{
            rolloverFunds: rolloverUnlockedFunds,
            traditionalFunds: traditionalUnlockedFunds,
          }}
          nextStep={
            selectedDestination === BANK_STEP ||
            selectedDestination === ADDRESS_STEP
              ? FREQUENCY_STEP
              : REINVEST_STEP
          }
          {...props}
        >
          <ProgressBar completedSteps={[0]} activeIndex={1} />
        </ProgressButtons>
      </div>
      <PageWrapper
        step={PROPORTIONATE_DISTRIBUTION_METHOD_STEP}
        isHelpCol={true}
      >
        <div className="scroll-wrapper">
          <div className="reinvest-title">
            These are the IRAs we will <br /> proportionally withdraw from:
          </div>
          <div className={styles['option-container']}>
            <div className={styles['fund-list']}>
              {rolloverUnlockedFunds.length > 0 && (
                <>
                  <div className={styles['sub-title']}> {'Rollover IRA'}</div>
                  {rolloverUnlockedFunds.map((fund, index) => (
                    <DestinationOption
                      key={index}
                      isSelected={true}
                      optionText={
                        <FundDisplayText
                          retirement={true}
                          balanceAsOfDate={balanceAsOfDate}
                          fund={fund}
                        />
                      }
                      selectable
                      value={1}
                      reinvest={true}
                      rollLastFund={rolloverUnlockedFunds.length - 1 === index}
                      proportionateFunds={true}
                    />
                  ))}
                </>
              )}
              {traditionalUnlockedFunds.length > 0 && (
                <>
                  <div className={styles['sub-title']}>
                    {' '}
                    {'Traditional IRA'}
                  </div>
                  {traditionalUnlockedFunds.map((fund, index) => (
                    <DestinationOption
                      key={index}
                      isSelected={true}
                      optionText={
                        <FundDisplayText
                          retirement={true}
                          balanceAsOfDate={balanceAsOfDate}
                          fund={fund}
                        />
                      }
                      selectable
                      value={1}
                      reinvest={true}
                      tradLastFund={
                        traditionalUnlockedFunds.length - 1 === index
                      }
                      proportionateFunds={true}
                    />
                  ))}
                </>
              )}
            </div>
            <HelpBox step={DISTRIBUTION_METHOD_STEP} />
            <RMLConnection phoneNumber={TOLL_FREE_NUMBER} />
          </div>
        </div>
      </PageWrapper>
    </div>
  );
};

export default ProportionateDistributionMethod;
